import { useEffect, useRef, useState } from 'react';
import { useForm } from "react-hook-form";
import { useQueryClient } from "react-query";
import * as apiClient from "../api-client";
import { useNavigate } from "react-router-dom";
import { VoucherClaimedType } from '../../../backend/src/models/socialBookings';

export type SocialBookingsFormData = {
  firstName: string;
  lastName: string;
  contactNumber?: string;
  email: string;
  departureCountry: string;
  arrivalCountry: string;
  travelers: string;
  adults: string;
  children: string;
  message: string;
  voucherCode?: string;
  terms?: boolean;
};

// type PromotionAlertBarProps = {
//   onClaim: () => void;
//   claimedCount: number;
// };

// const PromotionAlertBar = ({ onClaim, claimedCount }: PromotionAlertBarProps) => {
//   const [isVisible, setIsVisible] = useState(false);

//   useEffect(() => {
//     const handleScroll = () => {
//       if (window.scrollY > 100) {
//         setIsVisible(!localStorage.getItem("voucherClaimed"));
//         //setIsVisible(true);
//       } else {
//         setIsVisible(false);
//       }
//     };

//     window.addEventListener("scroll", handleScroll);

//     return () => {
//       window.removeEventListener("scroll", handleScroll);
//     };
//   }, []);

//   return (
//     isVisible && (
//       <div className="fixed top-0 left-0 right-0 bg-gray-100 text-white py-3 px-4 shadow-md z-50">
//         <div className="flex justify-between items-center">
//           <div>
//             <p className="text-gray-800"> <span className='text-lg text-black text-bold'> Hurry! </span>Subscribe to our Halo Community and Claim a further <span className='text-green-600'>  £200 discount voucher now! </span> <span className='text-halo-pink'>{claimedCount}</span>  out of <span className='text-halo-pink'>30 </span>  vouchers claimed.</p>

//           </div>
//           <button
//             className="bg-white text-halo-pink px-4 py-2 rounded-lg font-semibold hover:bg-gray-100"
//             onClick={onClaim}
//           >
//             Claim Here
//           </button>
//         </div>
//       </div>
//     )
//   );
// };

const SocialBookNow = () => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const [loading, setLoading] = useState(false);
  //const [price, setPrice] = useState(1849.00);
  const [discount, setDiscount] = useState(0);
  //const [showVoucherPopup, setShowVoucherPopup] = useState(false);
  const [voucher, setVoucher] = useState("");
  //const [claimedCount, setClaimedCount] = useState(5); // Example count of claimed vouchers
  const [claimedVouchers, setClaimedVouchers] = useState<VoucherClaimedType[]>([]);
  // const [claimedVoucherData, setClaimedVoucherData] = useState({
  //   firstName: '',
  //   lastName: '',
  //   contact: '',
  //   email: ''
  // });

  const isVoucherClaimed = localStorage.getItem('voucherClaimed') === 'true';

  useEffect(() => {
    const fetchClaimedVouchers = async () => {
      try {
        const claimedVoucherList = await apiClient.fetchVoucherClaimed();
        setClaimedVouchers(Array.isArray(claimedVoucherList) ? claimedVoucherList : []);
      } catch (error) {
        console.error("Error fetching claimed vouchers:", error);
        if (error instanceof Error) {
          console.error("Error message:", error.message);
        }
      }
    };

    fetchClaimedVouchers();
  }, []);

  useEffect(() => {
  }, [claimedVouchers]);

  useEffect(() => {
    const timestamp = localStorage.getItem('voucherTimestamp');
    if (timestamp) {
      const currentTime = new Date().getTime();
      const oneHour = 60 * 60 * 1000;
      if (currentTime - parseInt(timestamp) > oneHour) {
        localStorage.removeItem('voucherClaimed');
        localStorage.removeItem('voucherCode');
        localStorage.removeItem('voucherTimestamp');
      }
    }

    if (isVoucherClaimed) {
      setVoucher(localStorage.getItem('voucherCode') || '');
      setDiscount(200.00);
    }
  }, [isVoucherClaimed]);

  const {
    register,
    formState: { errors },
    handleSubmit,
    watch,
    setValue,
  } = useForm<SocialBookingsFormData>();

  const adults = watch("adults");
  const children = watch("children");
  const price = 1849.00;

  useEffect(() => {
    setValue("travelers", `${Number(adults) + Number(children)}`);
  }, [adults, children, setValue]);

  // useEffect(() => {
  //   if (claimedVoucherData.firstName) setValue("firstName", claimedVoucherData.firstName);
  //   if (claimedVoucherData.lastName) setValue("lastName", claimedVoucherData.lastName);
  //   if (claimedVoucherData.contact) setValue("contactNumber", claimedVoucherData.contact);
  //   if (claimedVoucherData.email) setValue("email", claimedVoucherData.email);
  // }, [claimedVoucherData, setValue]);

  const termsRef = useRef<HTMLInputElement>(null);

  const onSubmit = handleSubmit(async (data) => {

    if (!termsRef.current?.checked) {
      alert("You must agree to the terms and conditions.");
    return;
    }
    setLoading(true);
    try {
      const voucherCode = voucher;
      await apiClient.saveSocialBookingToDatabase({...data, voucherCode}, new Date().toISOString());
      await apiClient.sendSocialBookingEmail(data);
      queryClient.invalidateQueries("socialBookings");
      navigate("/success");
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  });

  // const handleClaimVoucher = async (data: { firstName: string; lastName: string; contact: string; email: string; terms: boolean; consent: boolean; voucherCode: string }) => {
  //   if (!data.terms) {
  //     alert("You must agree to the terms and conditions.");
  //     return;
  //   }

  //   if (claimedVouchers.length >= 30) {
  //     alert("All vouchers have been claimed.");
  //     return;
  //   }
  //   const randomVoucher = `DISCOUNT-${Math.floor(1000 + Math.random() * 9000)}`;
  //   setVoucher(randomVoucher);
  //   setDiscount(200.00);
  //   setShowVoucherPopup(false);

  //   try {
  //     await apiClient.createVoucherClaimed({
  //       firstName: data.firstName,
  //       lastName: data.lastName,
  //       contactNumber: data.contact,
  //       email: data.email,
  //       voucherCode: randomVoucher,
  //     });
  //     setClaimedVouchers((prev) => [...prev, { _id: '', firstName: data.firstName, lastName: data.lastName, contactNumber: data.contact, email: data.email, voucherCode: randomVoucher } as VoucherClaimedType]);
  //     const timestamp = new Date().getTime();
  //     localStorage.setItem("voucherClaimed", "true");
  //     localStorage.setItem('voucherCode', randomVoucher);
  //     localStorage.setItem('voucherTimestamp', timestamp.toString());

  //     setClaimedVoucherData({
  //       firstName: data.firstName,
  //       lastName: data.lastName,
  //       contact: data.contact,
  //       email: data.email
  //     });

  //     await apiClient.sendVoucherClaimedEmail({
  //       _id: '',
  //       firstName: data.firstName,
  //       lastName: data.lastName,
  //       contactNumber: data.contact,
  //       email: data.email,
  //       voucherCode: randomVoucher,
  //     } as VoucherClaimedType);

  //   } catch (error) {
  //     console.error("Error claiming voucher:", error);
  //     alert("Failed to claim voucher. Please try again later.");
  //   }
  // };

  return (
    <div className="flex flex-col items-center justify-center py-10 px-5 bg-gray-100">
      {/* <PromotionAlertBar onClaim={() => setShowVoucherPopup(true)} claimedCount={claimedVouchers.length} /> */}

      {/* {showVoucherPopup && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-md relative">
            <button className="absolute top-2 right-2 text-gray-500 hover:text-gray-700" onClick={() => setShowVoucherPopup(false)}>
              <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
            <h2 className="text-lg font-bold mb-4">Claim Your Voucher</h2>
            <form
              onSubmit={(e) => {
                e.preventDefault();
                const formData = new FormData(e.target as HTMLFormElement);
                const firstName = formData.get("firstName") as string;
                const lastName = formData.get("lastName") as string;
                const contact = formData.get("contact") as string;
                const email = formData.get("email") as string;
                const terms = formData.get("terms") === "on";
                const consent = formData.get("consent") === "on";
                const voucherCode = voucher;
                handleClaimVoucher({ firstName, lastName, contact, email, terms, consent, voucherCode });
              }}
              className="space-y-4"
            >
              <div>
                <label htmlFor="firstName" className="block text-sm font-medium text-gray-700">First Name</label>
                <input
                  id="firstName"
                  name="firstName"
                  type="text"
                  required
                  className="w-full border rounded-lg px-3 py-2 mt-1 focus:outline-none focus:ring-1 focus:ring-pink-500"
                />
              </div>
              <div>
                <label htmlFor="lastName" className="block text-sm font-medium text-gray-700">Last Name</label>
                <input
                  id="lastName"
                  name="lastName"
                  type="text"
                  required
                  className="w-full border rounded-lg px-3 py-2 mt-1 focus:outline-none focus:ring-1 focus:ring-pink-500"
                />
              </div>
              <div>
                <label htmlFor="contact" className="block text-sm font-medium text-gray-700">Contact</label>
                <input
                  id="contact"
                  name="contact"
                  type="text"
                  required
                  className="w-full border rounded-lg px-3 py-2 mt-1 focus:outline-none focus:ring-1 focus:ring-pink-500"
                />
              </div>
              <div>
                <label htmlFor="email" className="block text-sm font-medium text-gray-700">Email</label>
                <input
                  id="email"
                  name="email"
                  type="email"
                  required
                  className="w-full border rounded-lg px-3 py-2 mt-1 focus:outline-none focus:ring-1 focus:ring-pink-500"
                />
              </div>
              <div>
                <div className="flex items-center space-x-2">
                  <input
                    id="terms"
                    name="terms"
                    type="checkbox"
                    className="h-4 w-4 text-pink-500 border-gray-300 rounded focus:ring-pink-500"
                    defaultChecked={true}
                  />
                  <label htmlFor="terms" className="text-sm text-gray-700">
                    I agree to the <a href="/terms" target="_blank" rel="noopener noreferrer" className="text-pink-500 underline">terms and conditions</a>.
                  </label>
                </div>
                <div className="flex items-center space-x-2 mt-2">
                  <input
                    id="consent"
                    name="consent"
                    type="checkbox"
                    className="h-4 w-4 text-pink-500 border-gray-300 rounded focus:ring-pink-500"
                    defaultChecked={true}
                  />
                  <label htmlFor="consent" className="text-sm text-gray-700">
                    I agree to receive newsletters and promotional emails.
                  </label>
                </div>
              </div>
              <button
                type="submit"
                className="w-full bg-pink-500 text-white py-3 font-semibold rounded-lg hover:bg-pink-700 focus:outline-none"
              >
                Claim Voucher
              </button>
            </form>
          </div>
        </div>
      )} */}

      <div className="w-full max-w-4xl bg-white rounded-lg shadow-lg p-8">
        <header className="text-center mb-6">
          <img
            src="/new-halo-logo.svg"
            alt="Halo Holidays logo"
            className="mx-auto mb-4"
            style={{ width: '13rem', height: '3rem' }}
          />
          <h1 className="text-2xl font-bold text-gray-800">Plan Your Dream Trip to Sri Lanka 🌴</h1>
          <p className="text-gray-600 mt-2">
            Discover unforgettable adventures, luxury stays, and breathtaking landscapes with our 10-night package.
          </p>
        </header>

        <section className="mb-6 p-6 bg-gray-50 rounded-lg border border-gray-200">
          <h2 className="text-lg font-semibold text-gray-700 mb-4">What's Included?</h2>
          <ul className="grid grid-cols-1 md:grid-cols-2 gap-2 text-gray-600">
            <li className="flex items-center"><span className="text-green-500 mr-2">✔</span>International air tickets</li>
            <li className="flex items-center"><span className="text-green-500 mr-2">✔</span>4-star stays with breakfast</li>
            <li className="flex items-center"><span className="text-green-500 mr-2">✔</span>Guided private transfers</li>
            <li className="flex items-center"><span className="text-green-500 mr-2">✔</span>Temple of the Tooth Relic.</li>
            <li className="flex items-center"><span className="text-green-500 mr-2">✔</span>Sigiriya Rock Fortress</li>
            <li className="flex items-center"><span className="text-green-500 mr-2">✔</span>Pinnawala Elephant Orphanage.</li>
            <li className="flex items-center"><span className="text-green-500 mr-2">✔</span>Dambulla Cave Temple.</li>
            <li className="flex items-center"><span className="text-green-500 mr-2">✔</span>Yala Safari (jeep included).</li>
            <li className="flex items-center"><span className="text-green-500 mr-2">✔</span>Scenic train from Nanu Oya to Ella</li>
          </ul>
        </section>

        <div className="text-center mb-6">
          {discount > 0 && isVoucherClaimed ? (
            <>
              <p className="text-xl font-bold text-gray-800 line-through">£{price.toFixed(2)}pp</p>
              <div className="text-left mt-4">
                <div className='flex justify-between'>
                <p className="text-md font-medium text-gray-800">Price was:</p><p className="text-xl font-bold text-gray-800 line-through">£{price.toFixed(2)}pp</p> </div>
                <div className='flex justify-between'>
                <p className="text-md font-medium flex text-gray-800">Discount Applied  {voucher && (

            <p className="px-1 text-green-500 font-medium text-md"> (Your Voucher Code: {voucher})</p>

        )}:</p> <p>-£{discount.toFixed(2)}</p> </div>
        <div className='flex justify-between'>
                <p className="text-md font-medium text-gray-800">Total Price: </p> <p className='font-medium text-xl text-gray-800'>£{(price - discount).toFixed(2)}pp</p></div>
              </div>
            </>
          ) : (
            <p className="text-xl font-bold text-gray-800">£{price.toFixed(2)}pp</p>
          )}
        </div>

        <form className="space-y-6" onSubmit={onSubmit}>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label htmlFor="firstName" className="block text-sm font-medium text-gray-700">First Name</label>
              <input
                id="firstName"
                type="text"
                {...register("firstName", { required: "First name is required" })}
                className="w-full border rounded-lg px-3 py-2 mt-1 focus:outline-none focus:ring-1 focus:ring-pink-500"
              />
              {errors.firstName && <p className="text-red-500 text-xs mt-1">{errors.firstName.message}</p>}
            </div>
            <div>
              <label htmlFor="lastName" className="block text-sm font-medium text-gray-700">Last Name</label>
              <input
                id="lastName"
                type="text"
                {...register("lastName", { required: "Last name is required" })}
                className="w-full border rounded-lg px-3 py-2 mt-1 focus:outline-none focus:ring-1 focus:ring-pink-500"
              />
              {errors.lastName && <p className="text-red-500 text-xs mt-1">{errors.lastName.message}</p>}
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label htmlFor="email" className="block text-sm font-medium text-gray-700">E-mail</label>
              <input
                id="email"
                type="email"
                {...register("email", { required: "Email is required" })}
                className="w-full border rounded-lg px-3 py-2 mt-1 focus:outline-none focus:ring-1 focus:ring-pink-500"
              />
              {errors.email && <p className="text-red-500 text-xs mt-1">{errors.email.message}</p>}
            </div>
            {/* <div>
              <label htmlFor="contactNumber" className="block text-sm font-medium text-gray-700">Contact Number (Optional)</label>
              <input
                id="contactNumber"
                type="text"
                {...register("contactNumber")}
                className="w-full border rounded-lg px-3 py-2 mt-1 focus:outline-none focus:ring-1 focus:ring-pink-500"
              />
            </div> */}
          </div>

          {/* <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label htmlFor="departureCountry" className="block text-sm font-medium text-gray-700">Departure</label>
              <input
                id="departureCountry"
                type="text"
                {...register("departureCountry", { required: "Departure country is required" })}
                className="w-full border rounded-lg px-3 py-2 mt-1 focus:outline-none focus:ring-1 focus:ring-pink-500"
              />
              {errors.departureCountry && <p className="text-red-500 text-xs mt-1">{errors.departureCountry.message}</p>}
            </div>
            <div>
              <label htmlFor="arrivalCountry" className="block text-sm font-medium text-gray-700">Arrival</label>
              <input
                id="arrivalCountry"
                type="text"
                {...register("arrivalCountry", { required: "Arrival country is required" })}
                className="w-full border rounded-lg px-3 py-2 mt-1 focus:outline-none focus:ring-1 focus:ring-pink-500"
              />
              {errors.arrivalCountry && <p className="text-red-500 text-xs mt-1">{errors.arrivalCountry.message}</p>}
            </div>
          </div>

          <div className="grid grid-cols-3 gap-4">
            <div>
              <label htmlFor="adults" className="block text-sm font-medium text-gray-700">Adults</label>
              <input
                id="adults"
                type="number"
                {...register("adults", { required: "Number of adults is required" })}
                className="w-full border rounded-lg px-3 py-2 mt-1 focus:outline-none focus:ring-1 focus:ring-pink-500"
              />
              {errors.adults && <p className="text-red-500 text-xs mt-1">{errors.adults.message}</p>}
            </div>
            <div>
              <label htmlFor="children" className="block text-sm font-medium text-gray-700">Children</label>
              <input
                id="children"
                type="number"
                {...register("children", { required: "Number of children is required" })}
                className="w-full border rounded-lg px-3 py-2 mt-1 focus:outline-none focus:ring-1 focus:ring-pink-500"
              />
              {errors.children && <p className="text-red-500 text-xs mt-1">{errors.children.message}</p>}
            </div>
            <div>
              <label htmlFor="travelers" className="block text-sm font-medium text-gray-700">Travelers</label>
              <input
                id="travelers"
                type="number"
                readOnly
                {...register("travelers")}
                className="w-full border rounded-lg px-3 py-2 mt-1 bg-gray-100 cursor-not-allowed"
              />
            </div>
          </div>

          <div>
            <label htmlFor="message" className="block text-sm font-medium text-gray-700">Message</label>
            <textarea
              id="message"
              {...register("message")}
              className="w-full border rounded-lg px-3 py-2 mt-1 focus:outline-none focus:ring-1 focus:ring-pink-500"
              rows={4}
            />
          </div> */}

          <div>
            <div className="flex items-center space-x-2">
              <input
                    id="terms"
                    name="terms"
                    type="checkbox"
                    ref={termsRef}
                    //onChange={(e) => setTermsChecked(e.target.checked)}
                    className="h-4 w-4 text-pink-500 border-gray-300 rounded focus:ring-pink-500"
                    defaultChecked={false}
                  />
                  <label htmlFor="terms" className="text-sm text-gray-700">
                    I agree to the <a href="/terms" target="_blank" rel="noopener noreferrer" className="text-pink-500 underline">terms and conditions</a>.
                  </label>
                </div>
                <div className="flex items-center space-x-2 mt-2">
                  <input
                    id="consent"
                    name="consent"
                    type="checkbox"
                    className="h-4 w-4 text-pink-500 border-gray-300 rounded focus:ring-pink-500"
                    defaultChecked={false}
                  />
                  <label htmlFor="consent" className="text-sm text-gray-700">
                    I agree to receive newsletters and promotional emails.
                  </label>
                </div>
                <div className="text-sm text-gray-700 mt-2">
                  By submitting this form, you agree to our Privacy Policy and that your data will be used for inquiry purposes only.
                </div>
          </div>

          <button
            type="submit"
            className="w-full bg-pink-500 text-white py-3 font-semibold rounded-lg hover:bg-pink-700 focus:outline-none"
            disabled={loading}
          >
            {loading ? 'Submitting...' : 'Submit Inquiry'}
          </button>
        </form>

        <div className="mt-6 text-center text-gray-700">
          Our team will contact you shortly to assist with your booking.
        </div>

        <div className='text-right mt-1 text-sm'>
          <a href="/terms" target="_blank" rel="noopener noreferrer" className="text-pink-500 underline">Privacy and policy</a>
        </div>

        {/* {voucher && (
          <div className="mt-6 text-center">
            <p className="text-green-500 font-bold">Your Voucher Code: {voucher}</p>
          </div>
        )} */}
      </div>
    </div>
  );
};

export default SocialBookNow;
